// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__eYefp","plus":"styles_plus__KD7VU","key":"styles_key__ygNuP"};